import React, { useState } from 'react';
import Actions from '@/components/buttons/Actions';
import DualActions from '@/components/buttons/DualActions';
import { states } from '@/constants/lifecycle';
import { hasMinimumLength } from '@/utils/resultsHelper';

const RequestTransferDialogActions = ({
  hide,
  loading,
  results,
  supportsAutoTransfer,
  transfer,
  url,
}) => {
  const [automatic, setAutomatic] = useState(false);

  const saving = (auto) => automatic === auto && results.some((result) => result.saveStatus === states.PENDING);

  const submitForm = (auto) => {
    setAutomatic(auto);
    transfer(results, auto);
  };

  return (
    <>
      {supportsAutoTransfer && (
        <DualActions
          onClose={hide}
          onSavePrimary={() => submitForm(true)}
          onSaveSecondary={() => submitForm(false)}
          primaryDataEntryMet={!loading && hasMinimumLength(url)}
          primarySaveMessageId="request.transfer.button"
          savingPrimary={saving(true)}
          savingSecondary={saving(false)}
          secondaryDataEntryMet={!loading}
          secondarySaveMessageId="request.mark.transfer.button"
        />
      )}
      {!supportsAutoTransfer && (
        <Actions
          minimumDataEntryMet={!loading}
          onClose={hide}
          inProgress={saving(false)}
          onSave={() => submitForm(false)}
          saveMessageId="request.mark.transfer.button"
        />
      )}
    </>
  );
};

export default RequestTransferDialogActions;
